'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["$minHeight", "$maxHeight"];
import { useLayoutEffect } from 'react';
import styled from 'styled-components';
import useComponentId from '../hooks/useComponentId';
import { jsx as _jsx } from "react/jsx-runtime";
const TinyMCEContainer = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest));
}).withConfig({
  displayName: "TinymceInline__TinyMCEContainer",
  componentId: "hj8sxn-0"
})(["", " ", ";"], ({
  $minHeight
}) => $minHeight && `min-height: ${$minHeight}px !important;`, ({
  $maxHeight
}) => $maxHeight && `max-height: ${$maxHeight}px !important; overflow-y: auto;`);
const TinymceInline = ({
  className,
  minHeight,
  maxHeight,
  uniqueKey,
  target,
  id,
  content,
  editor,
  initialized,
  config,
  'data-test-id': dataTestId,
  'data-onboarding': dataOnboarding
}) => {
  const inpageWithTarget = target && config.hsInpage;
  const key = useComponentId();

  // The setting of content like this is to avoid dangerously setting markup if inline is running on our domain.
  // inpageWithTarget is a heuristic to know if we should leave the content alone after init
  // This hook is only meant to fire on the change of `initialized` as editor and content props should not be controlled.
  useLayoutEffect(() => {
    if (initialized && !inpageWithTarget) {
      editor.setContent(content);
    }
  }, [initialized, content, editor, inpageWithTarget]);
  if (target) {
    return null;
  }
  const extraProps = config.hsInpage ? {} : {
    translate: 'no'
  };
  return /*#__PURE__*/_jsx(TinyMCEContainer, Object.assign({
    id: id,
    className: className,
    "data-test-id": dataTestId,
    "data-onboarding": dataOnboarding,
    $minHeight: minHeight,
    $maxHeight: maxHeight
  }, extraProps), uniqueKey || key);
};
export default TinymceInline;